import React from "react";

import { Box, styled } from "@mui/material";

import { NavigationSync } from "@features/navigation/components";

const Frame = styled(Box)(() => ({
  display: "flex",
  position: "relative",
  width: "100%",
  height: "100vh",
  minHeight: "100vh",
}));

const Wrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  position: "relative",
}));

const Navigation = ({ children }) => (
  <Frame>
    <NavigationSync />
    <Wrapper>
      {children}
    </Wrapper>
  </Frame>
);

export default Navigation;
